import React from "react";
import { observer } from "mobx-react";
import GetCoordinates from "../../Queries/GetBookings";

const MapView = observer(({ store, bStore, history }) => (
  <GetCoordinates store={store} bStore={bStore} history={history} />
));

export default MapView;
